import { apiCreate } from './ApiBaseActions';
export const API_CREATE_USER_PAGE_VIEW_ACTION = 'API_CREATE_USER_PAGE_VIEW_ACTION';
export const API_UPDATE_USER_PAGE_VIEW_ACTION = 'API_UPDATE_USER_PAGE_VIEW_ACTION';
export const API_CREATE_USER_PAGE_VIEW_ACTION_ACTION = 'API_CREATE_USER_PAGE_VIEW_ACTION_ACTION';
export const SET_USER_PAGE_VIEW_ID_ACTION = 'SET_USER_PAGE_VIEW_ID_ACTION';
/**
 * ページ閲覧履歴の作成
 * @param request
 * @param meta
 */
export const apiCreateUserPageViewAction = (request, meta) => apiCreate(API_CREATE_USER_PAGE_VIEW_ACTION, '/page_view', request.json, meta);
/**
 * ページ閲覧履歴の更新
 * @param request
 * @param meta
 */
export const apiUpdateUserPageViewAction = (request, meta) => apiCreate(API_UPDATE_USER_PAGE_VIEW_ACTION, `/page_view/${request.path.id}`, request.json, meta);
/**
 * ページ閲覧履歴にひもづくデータの登録
 * @param request
 * @param meta
 */
export const apiCreateUserPageViewActionAction = (request, meta) => apiCreate(API_CREATE_USER_PAGE_VIEW_ACTION_ACTION, `/page_view/${request.path.id}/action`, request.json, meta);
/**
 * ページビューのIDをreducerに保持する
 * @param id
 */
export const setUserPageViewIdAction = (id) => ({
    payload: { id },
    type: SET_USER_PAGE_VIEW_ID_ACTION,
});
